import React from 'react';
import { USE_TWILIO_VIDEO } from '@/shared/constants/flags';
import ZoomVideoFeed from './ZoomVideoFeed';
import TwilioVideoFeed from './TwilioVideoFeed';

const VideoFeed = () => {
  if (USE_TWILIO_VIDEO) {
    return <TwilioVideoFeed />;
  }

  return <ZoomVideoFeed />;
};

export default VideoFeed;
